// This file centralizes configuration variables for the frontend.
// In a live environment, process.env.REACT_APP_API_URL should be set (e.g., in a .env file or host config).
// If it's not set, it defaults to the local backend url for development.

export const API_URL = process.env.REACT_APP_API_URL;
